let environment = {}

if (process.env.NODE_ENV === 'production') {
	environment = {
		// https://182.92.11.148:8443
		// https://www.smart-core.cn:8443/
		host: "www.smart-core.cn",
		port: "8443",
		protocol: "https:",

		remote: 'www.smart-core.cn:8443',
		origin: "https://www.smart-core.cn:8443",
		production: true,
	};
}
else if (process.env.NODE_ENV === 'development') {
	environment = {
		// host: 'localhost',
		// port: '3000',
		// protocol: 'http:',
		//
		// remote: 'localhost:3000',
		// origin: 'http://localhost:3000',
		host: "www.smart-core.cn",
		port: "8443",
		protocol: "https:",

		remote: 'www.smart-core.cn:8443',
		origin: "https://www.smart-core.cn:8443",
		production: false,
	};
}
// https://www.smart-core.cn/home
// http://localhost:3001/homepage

export default environment
export const getRootUrl = () => environment.protocol+'//'+environment.host+':'+environment.port
// export const getRootUrl = () => ""
export const getImgUrl = () => environment.protocol+'//'+environment.host+':'+environment.port + '/';
export const wsUrl = "ws://"+environment.host+":"+environment.port+"/ws"
export const externalLink = 'https://192.168.252.9:8001/'
export const govLink = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802047973'
